
  export default {
    props: {
      product: {
        type: String,
        required: true
      }
    },
    data () {
      return { progressAdjustment: 375, progressBar: null, progressHeight: 0, progressOffset: 0 };
    },
    mounted () {
      this.createProgressBar();
      this.eventProgressBar();
      this.startProgressBarListener();
    },
    beforeDestroy () {
      this.stopProgressBarListener();
    },
    methods: {
      createProgressBar () {
        this.progressBar = this.$el.querySelector('.progress-bar');
        const progressContainer = this.$el.querySelector('.progress-container');
        if (progressContainer && this.progressBar) {
          this.progressOffset = progressContainer.offsetTop + this.progressAdjustment;
        }
      },
      eventProgressBar () {
        this.progressHeight = window.scrollY - this.progressOffset;
        this.$el.querySelectorAll('.box-container').forEach(box => {
          const circle = box.querySelector('.box-circle');
          if (circle) {
            const edge = box.offsetTop + circle.offsetHeight;
            const isCovered = edge < this.progressHeight;
            circle.classList[isCovered ? 'add' : 'remove']('progress-green');
          }
        });
      },
      startProgressBarListener () {
        window.addEventListener('scroll', this.eventProgressBar);
      },
      stopProgressBarListener () {
        window.removeEventListener('scroll');
      }
    }
  };
